module.exports = __webpack_public_path__ + "img/PowerPointLogo.b0dc5fbe.svg";